import styled from "@emotion/styled";
import { Swiper, SwiperSlide } from "swiper/react";

const SwiperStyled = styled(Swiper, {
  shouldForwardProp: prop => prop !== "addStyles",
})`
  display: flex !important;
  flex-direction: column-reverse;

  .swiper-pagination-bullet {
    width: 20px !important;
    height: 20px !important;
    border: 3px solid ${props => props.theme.colors.secondary.minor} !important;
    background-color: ${props => props.theme.colors.background} !important;
    opacity: 1 !important;

    @media (min-width: ${props => props.theme.screenSizes.mdMax}) {
      border: 3px solid ${props => props.theme.colors.secondary.gray} !important;
    }
  }

  .swiper-pagination-bullet-active {
    background-color: ${props => props.theme.colors.black} !important;
    border-color: ${props => props.theme.colors.black} !important;
  }

  .MuiButtonBase-root:disabled {
    cursor: not-allowed;
  }

  ${props => props.addStyles}
`;

const SwiperSlideStyled = styled(SwiperSlide, {
  shouldForwardProp: prop => prop !== "slideFullWidth",
})`
  ${props =>
    !props.slideFullWidth &&
    `
   
    width: 260px !important;

  @media (min-width: ${props.theme.screenSizes.mdMax}) {
    height: 251px !important;
    width: 280px !important;
  }
  `}
`;

const WrapperRoot = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  margin-right: ${p => p.theme.space[6]}px;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    margin-bottom: 0;
    margin-right: 0;
    flex-direction: row;
  }

  @media (max-width: ${p => p.theme.screenSizes.lgMin}) {
    padding-right: ${p => p.theme.space[6]}px;
  }
`;

const WrapperButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: ${p => p.theme.space[4]}px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    gap: ${p => p.theme.space[5]}px;
  }
`;

export { SwiperStyled, SwiperSlideStyled, WrapperRoot, WrapperButtons };
